import { render } from "./GridInfo.vue?vue&type=template&id=daa1f852&scoped=true&ts=true"
import script from "./GridInfo.vue?vue&type=script&lang=ts"
export * from "./GridInfo.vue?vue&type=script&lang=ts"

import "./GridInfo.vue?vue&type=style&index=0&id=daa1f852&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daa1f852"]])

export default __exports__